<template>
  <div class="preika-auth-page">
    <section class="preika-error-panel">
      <img
        src="/img/avatars/preika_black.png"
        :alt="productName"
        class="preika-error-panel__logo"
      >
      <span class="preika-error-panel__icon">
        <CIcon name="cil-lock-locked"/>
      </span>
      <p class="preika-error-panel__eyebrow">ACCESS DENIED</p>
      <h1>この画面は現在の契約・役割では利用できません</h1>
      <p>
        契約プランで対象機能が利用でき、かつ担当業務に必要な役割と利用権限が
        設定されている場合だけ開けます。権限変更後は一度ログアウトして再ログインしてください。
      </p>
      <div class="preika-error-panel__actions">
        <router-link to="/dashboard" class="btn btn-primary">
          ダッシュボードへ戻る
          <CIcon name="cil-arrow-right"/>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { PRODUCT_NAME } from '@/common/productName'

export default {
  name: 'AccessDenied',

  computed: {
    /** 売るときの正式な表記。**1か所から取る。** */
    productName () {
      return PRODUCT_NAME
    }
  },
}
</script>

<style scoped>
.preika-error-panel {
  position: relative;
  z-index: 1;
  width: min(100%, 650px);
  padding: 52px;
  border: 1px solid rgba(255, 255, 255, .85);
  border-radius: 25px;
  background: rgba(255, 255, 255, .96);
  box-shadow: 0 30px 80px rgba(7, 52, 87, .17);
  text-align: center;
}

.preika-error-panel__logo {
  width: 150px;
  max-height: 48px;
  margin-bottom: 25px;
  object-fit: contain;
}

.preika-error-panel__icon {
  display: inline-flex;
  width: 70px;
  height: 70px;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  border-radius: 23px;
  background: rgba(224, 145, 29, .12);
  color: #a76108;
  font-size: 34px;
}

.preika-error-panel__eyebrow {
  margin: 10px 0 0 !important;
  color: #a76108 !important;
  font-size: 9px !important;
  font-weight: 900;
  letter-spacing: .15em;
}

.preika-error-panel h1 {
  margin: 12px 0;
  color: var(--preika-navy-900);
  font-size: 24px;
  line-height: 1.5;
}

.preika-error-panel p {
  max-width: 520px;
  margin: 0 auto;
  color: var(--preika-text-muted);
  font-size: 12px;
  line-height: 1.9;
}

.preika-error-panel__actions {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}

@media (max-width: 575.98px) {
  .preika-error-panel {
    padding: 38px 23px;
  }

  .preika-error-panel h1 {
    font-size: 20px;
  }
}
</style>
